import { createStore , applyMiddleware, combineReducers} from 'redux';
import thunk from 'redux-thunk';
import {Replay} from './models';

import {dbReducer} from './lib/worm/reducers';
import appReducer from './redusers';
import {DB} from './lib/worm/db';

export let db = new DB([Replay], true);

export let store = createStore(combineReducers({app: appReducer, db: dbReducer}), applyMiddleware(thunk));

db.setStore(store);




// WEBPACK FOOTER //
// ./src/state.js